<mat-drawer-container class="scene-editor-container">
    <mat-drawer mode="side" position="start" opened [disableClose]="true">
        <app-scene-nav (whenMinimized)="onNavMinimized($event);" (whenMaximized)="onNavMaximized()"></app-scene-nav>
    </mat-drawer>
    <mat-drawer-content>
        @if (renderSceneContainer) {
            <div fxLayout="row" class="list-container main-container" fxFlex="100%">
                @if (viewMode !== 'collectionMode' &&
                viewMode !== 'playlistMode' &&
                viewMode !== 'locationMode' &&
                viewMode !== 'animationMode') {
                    <div class="sceneSubContainer">
                        <app-scene-builder #sceneBuilder
                                           (toggleMinimize)="toggleMinimize()"
                                           [setSceneData]="sceneData"
                                           [propsMinimized]="!sidenav.opened || sidenavMode === 'over'"
                                           [setSelectedSceneItemId]="selectedSceneItemId"
                                           [setSelectedSceneIdDataChanged]="sceneSlice"
                                           [setSelectedSceneId]="selectedSceneId">
                        </app-scene-builder>
                    </div>
                }
                @switch (viewMode) {
                    @case ('playlistMode') {
                        <div class="playlist-wrapper">
                            <app-playlist-editor
                                    [mode]="'playlistMode'"
                                    [propsMinimized]="!sidenav.opened || sidenavMode === 'over'"
                                    (toggleMinimize)="toggleMinimize()">
                            </app-playlist-editor>
                        </div>
                    }
                    @case ('collectionMode') {
                        <div class="playlist-wrapper">
                            <app-playlist-editor
                                    [mode]="'collectionMode'"
                                    [propsMinimized]="!sidenav.opened || sidenavMode === 'over'"
                                    (toggleMinimize)="toggleMinimize()">
                            </app-playlist-editor>
                        </div>
                    }
                    @case ('locationMode') {
                        <div class="list-container main-container location-wrapper">
                            <app-location-based
                                    [propsMinimized]="!sidenav.opened || sidenavMode === 'over'"
                                    (toggleMinimize)="toggleMinimize()">
                            </app-location-based>
                        </div>
                    }
                }
            </div>
        }
        @if (!renderSceneContainer) {
            <div class="loading-scene">
                <app-loading [type]="-1" [size]="'50px'"></app-loading>
            </div>
        }
    </mat-drawer-content>



    <mat-drawer [opened]="sidenavOpened" [mode]="sidenavMode" position="end" #sidenav disableClose>
        <div class="list-container scenePropsContainer" fxLayout="column">
            <div fxLayout="row" fxLayoutAlign="center" class="side-main-menu">
                @if (!minimized) {
                    <span class="drawerHeader" style="padding-top: 4px;">{{ 'general.properties' | transloco }}</span>
                    <mat-icon (click)="onMinimized()" style="position: absolute; left: 10px; top: 4px; cursor: pointer">keyboard_double_arrow_right</mat-icon>
                }
                @if (minimized) {
                    <mat-icon (click)="onMaximized()" style="position: absolute; left: 10px; top: 4px; cursor: pointer">keyboard_double_arrow_left</mat-icon>
                }
            </div>




            <mat-drawer-container class="drawer-container" style="height: 100%">
                <mat-drawer mode="side" position="end" opened style="width: 72px">
                    <div class="menu-button" [ngClass]="{'active': this.activeTemplate === 'details'}" (click)="setActiveTemplate('details')">
                        <fa-icon size="xl" class="faNav" [icon]="faWrench"></fa-icon>
                        {{ 'general.details' | transloco }}
                    </div>
                    @if (isBlockAnimation && isNotNested && renderSceneContainer && !multiple) {
                        <div class="menu-button" [ngClass]="{'active': this.activeTemplate === 'animation'}" (click)="setActiveTemplate('animation')">
                            <mat-icon style="margin-left: 5px; font-size: 24px;">flare</mat-icon>
                            {{ 'general.animation' | transloco }}
                        </div>
                    }
                    @if (isNotNested && renderSceneContainer && !multiple) {
                        <div *ngIf="showEffects" class="menu-button" [ngClass]="{'active': this.activeTemplate === 'effects'}" (click)="setActiveTemplate('effects')">
                            <mat-icon style="margin-left: 5px; font-size: 24px;">blur_on</mat-icon>
                            {{ 'general.effects' | transloco }}
                        </div>
                    }
                </mat-drawer>
                <mat-drawer-content [style.width.px]="minimized ? 0 : 265">
                    <div class="propertyPanel" >
                        <ng-container *ngTemplateOutlet="getTemplate(activeTemplate)"></ng-container>
                        <ng-template #detailsTemplate>
                            <mat-accordion [multi]="false" class="accordion-container">
                                <mat-expansion-panel #propPanel portalHandler [expanded]="false" (opened)="panelOpenState = true"
                                                     (closed)="panelOpenState = false" class="scrollable-panel">
                                    <mat-expansion-panel-header>
                                        <mat-panel-title>
                                            @if (blockIcon) {
                                            <fa-icon class="faIconPosition" size="lg" [icon]="blockIcon"></fa-icon>
                                            }
                                            <span class="accordionIcons">{{ blockMimeName }}</span>
                                        </mat-panel-title>
                                        <mat-panel-description>
                                        </mat-panel-description>
                                        @if (propPanel.expanded) {
                                        <app-video-link style="position: absolute; right: 40px; top: 15px" [videoLink]="'/help/'+blockVideoLinkName"></app-video-link>
                                        }

                                    </mat-expansion-panel-header>
                                    <ng-template matExpansionPanelContent>
                                        <div [@fadeProperty]="visibility" (@fadeProperty.done)="animationDone($event)">
                                            <app-block-loader></app-block-loader>
                                        </div>
                                        @if (!accessConfig?.upd) {
                                        <div class="only-view"></div>
                                        }
                                    </ng-template>
                                </mat-expansion-panel>
                                @if (isDataProvider) {
                                    <mat-expansion-panel portalHandler class="scrollable-panel">
                                        <mat-expansion-panel-header>
                                            <mat-panel-title>
                                                <fa-icon size="lg" class="faIconPosition" [icon]="faHdd"></fa-icon>
                                                <span class="accordionIcons">
                                                    data provider
                                                </span>
                                            </mat-panel-title>
                                            <mat-panel-description>
                                            </mat-panel-description>
                                        </mat-expansion-panel-header>
                                        <ng-template matExpansionPanelContent>
                                            <app-block-data-provider></app-block-data-provider>
                                        </ng-template>
                                        @if (!accessConfig?.upd) {
                                            <div class="only-view"></div>
                                        }
                                    </mat-expansion-panel>
                                }

                                @if (blockName === 'scene' && isPlayerAssignable && experienceLevel > experienceLevelType.BEGINNER) {
                                    <mat-expansion-panel portalHandler class="scrollable-panel">
                                        <mat-expansion-panel-header>
                                            <mat-panel-title>
                                                <fa-icon size="lg" [icon]="faPlugCircleCheck"></fa-icon>
                                                <span class="accordionIcons">{{ 'general.playerConfig' | transloco }}</span>
                                            </mat-panel-title>
                                            <mat-panel-description>
                                            </mat-panel-description>
                                        </mat-expansion-panel-header>
                                        <ng-template matExpansionPanelContent>
                                            <app-block-scene [sceneTopProps]="true"></app-block-scene>
                                        </ng-template>
                                        @if (!accessConfig?.upd) {
                                            <div class="only-view"></div>
                                        }
                                    </mat-expansion-panel>
                                }


                                <mat-expansion-panel portalHandler #layoutPanel class="scrollable-panel">
                                    <mat-expansion-panel-header>
                                        <mat-panel-title>
                                            <fa-icon size="lg" class="faIconPosition" [icon]="faObjectUngroup"></fa-icon>
                                            <span class="accordionIcons">{{ 'general.layout' | transloco }}</span>
                                        </mat-panel-title>
                                        <mat-panel-description>
                                        </mat-panel-description>

                                        @if (layoutPanel.expanded && experienceLevel > experienceLevelType.BEGINNER) {
                                        <app-video-link style="position: absolute; right: 40px; top: 15px" videoLink="layout"></app-video-link>
                                        }

                                    </mat-expansion-panel-header>
                                    <ng-template matExpansionPanelContent>
                                        <app-block-layout-common-props></app-block-layout-common-props>
                                        @if (!accessConfig?.upd) {
                                        <div class="only-view"></div>
                                        }
                                    </ng-template>
                                </mat-expansion-panel>
                                <!-- removed anchor support 9-21-2023 -->
                                <!--                        <mat-expansion-panel portalHandler *ngIf="isHostDevOrLocal && isAnchorSupport">-->
                                <!--                            <mat-expansion-panel-header>-->
                                <!--                                <mat-panel-title>-->
                                <!--                                    <fa-icon size="lg" [icon]="faAnchor"></fa-icon>-->
                                <!--                                    <span class="accordionIcons">{{'general.anchor' | transloco}}</span>-->
                                <!--                                </mat-panel-title>-->
                                <!--                                <mat-panel-description>-->
                                <!--                                </mat-panel-description>-->
                                <!--                            </mat-expansion-panel-header>-->
                                <!--                            <ng-template matExpansionPanelContent>-->
                                <!--                                <app-anchor></app-anchor>-->
                                <!--                            </ng-template>-->
                                <!--                            <div class="only-view" *ngIf="!accessConfig?.upd"></div>-->
                                <!--                        </mat-expansion-panel>-->
                                @if (showEvents && experienceLevel == experienceLevelType.ADVANCED) {
                                    <mat-expansion-panel #eventPanel portalHandler class="scrollable-panel">
                                        <mat-expansion-panel-header>
                                            <mat-panel-title>
                                                <fa-icon size="lg" class="faNav" [icon]="faBell"></fa-icon>
                                                <span class="accordionIcons">{{ 'general.events' | transloco }}</span>
                                            </mat-panel-title>
                                            <mat-panel-description>
                                            </mat-panel-description>
                                            @if (eventPanel.expanded) {
                                                <app-video-link style="position: absolute; right: 40px; top: 15px" videoLink="Button"></app-video-link>
                                            }
                                        </mat-expansion-panel-header>
                                        <ng-template matExpansionPanelContent>
                                            <mat-tab-group [@.disabled]="true" tabGroupDrag mat-stretch-tabs="false" mat-align-tabs="start">
                                                @if (isBlockAdvEvents?.send) {
                                                    <mat-tab label="{{'general.sendEvents' | transloco}}">
                                                        <app-block-send-events></app-block-send-events>
                                                    </mat-tab>
                                                }
                                                @if (isBlockAdvEvents?.receive) {
                                                    <mat-tab
                                                        label="{{'general.receiveEvents' | transloco}}">
                                                        <app-block-receive-events></app-block-receive-events>
                                                    </mat-tab>
                                                }
                                                @if (isBlockAdvEvents?.source) {
                                                    <mat-tab
                                                        label="{{'general.eventSource' | transloco}}">
                                                        <app-block-event-source></app-block-event-source>
                                                    </mat-tab>
                                                }
                                                @if (isBlockAdvEvents?.filter) {
                                                    <mat-tab label="{{'general.filters' | transloco}}">
                                                        <app-block-filter-events></app-block-filter-events>
                                                    </mat-tab>
                                                }
                                            </mat-tab-group>
                                        </ng-template>
                                        @if (!accessConfig?.upd) {
                                            <div class="only-view"></div>
                                        }
                                    </mat-expansion-panel>
                                }
                                @if (showPop && experienceLevel == experienceLevelType.ADVANCED) {
                                    <mat-expansion-panel #popPanel portalHandler class="scrollable-panel">
                                        <mat-expansion-panel-header>
                                            <mat-panel-title>
                                                <fa-icon size="lg" class="faNav" [icon]="faReceipt"></fa-icon>
                                                <span class="accordionIcons">{{ 'general.proofOfPlay' | transloco }}</span>
                                        </mat-panel-title>
                                        <mat-panel-description>
                                        </mat-panel-description>
                                        @if (popPanel.expanded) {
                                            <app-video-link style="position: absolute; right: 40px; top: 15px" videoLink="sign_pop"></app-video-link>
                                        }
                                        </mat-expansion-panel-header>
                                        <ng-template matExpansionPanelContent>
                                            <app-block-pop></app-block-pop>
                                        </ng-template>
                                        @if (!accessConfig?.upd) {
                                            <div class="only-view"></div>
                                        }
                                    </mat-expansion-panel>
                                }
                                @if (isFullFeatures && scriptingMode && renderSceneContainer && isSceneButNotNested && experienceLevel == experienceLevelType.ADVANCED) {
                                    <mat-expansion-panel portalHandler class="scrollable-panel">
                                        <mat-expansion-panel-header>
                                            <mat-panel-title>
                                                <fa-icon size="lg" class="faNav" [icon]="faCode"></fa-icon>
                                                <span class="accordionIcons">{{ 'general.scripts' | transloco }}</span>
                                            </mat-panel-title>
                                            <mat-panel-description>
                                            </mat-panel-description>
                                        </mat-expansion-panel-header>
                                        <ng-template matExpansionPanelContent>
                                            <app-block-scripts [setSelectedSceneId]="selectedSceneId"></app-block-scripts>
                                            @if (!accessConfig?.upd) {
                                                <div class="only-view"></div>
                                            }
                                        </ng-template>
                                    </mat-expansion-panel>
                                }
                            </mat-accordion>
                        </ng-template>

                        <ng-template #animationTemplate>
                            <app-block-animation-group></app-block-animation-group>
                        </ng-template>

                        <ng-template #effectsTemplate>
                            <app-block-effect-group></app-block-effect-group>
                        </ng-template>
                    </div>
                </mat-drawer-content>
            </mat-drawer-container>

        </div>
    </mat-drawer>
</mat-drawer-container>

<!-- <mat-accordion [multi]="false">
    <mat-expansion-panel #effectsPanel portalHandler>
        <mat-expansion-panel-header>
            <mat-panel-title>
                <fa-icon size="lg" class="faNav" [icon]="faCube"></fa-icon>
                <span class="accordionIcons">{{ 'general.effects' | transloco }}</span>
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
            @if (effectsPanel.expanded) {
            <app-video-link style="position: absolute; right: 40px; top: 10px" videoLink="effects"></app-video-link>
            }
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
            <mat-tab-group [@.disabled]="true" [(selectedIndex)]="selectedEffectIndex" tabGroupDrag #tabGroupAnimation class="mini-tab" mat-stretch-tabs="false" mat-align-tabs="start">
                <div>
                    @for (sceneEffect of sceneEffects; track sceneEffect) {
                    @if (sceneEffect.name != 'Layout' || selectedSceneItemId != selectedSceneId) {
                    <mat-tab>
                        <ng-template mat-tab-label>
                            <div class="tab-label">
                                <fa-icon size="lg" [icon]="sceneEffect.icon"></fa-icon>
                                {{ sceneEffect.translator | transloco }}
                            </div>
                        </ng-template>
                        <ng-template matTabContent>
                            <app-block-effects [effectName]="sceneEffect.name">
                            </app-block-effects>
                        </ng-template>
                    </mat-tab>
                    }
                    }
                </div>
                
            </mat-tab-group>
        </ng-template>
        @if (!accessConfig?.upd) {
        <div class="only-view"></div>
        }
    </mat-expansion-panel>
    <mat-expansion-panel #effectActionsPanel portalHandler>
        <mat-expansion-panel-header>
            <mat-panel-title>
                <fa-icon size="lg" class="faNav" [icon]="faRandom"></fa-icon>
                <span class="accordionIcons">{{ 'general.effectActions' | transloco }}</span>
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
            @if (effectActionsPanel.expanded) {
            <app-video-link style="position: absolute; right: 40px; top: 10px" videoLink="effectActions"></app-video-link>
            }

        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
            <app-block-effect-group (selectAnimation)="onSelectAnimation($event)">
            </app-block-effect-group>
            @if (!accessConfig?.upd) {
            <div class="only-view"></div>
            }
        </ng-template>
    </mat-expansion-panel>
</mat-accordion> -->

<!-- Deprecated
                @if (isBlockTransition) {
                    <mat-tab>
                    <ng-template mat-tab-label>
                        {{ 'general.transitions' | transloco }}aaa
                        <fa-icon size="lg" class="faNav" [icon]="faRandom"></fa-icon>
                    </ng-template>
                    <app-block-base-transitions></app-block-base-transitions>
                    </mat-tab>
                }
                -->
